






































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { VueEditor } from 'vue2-editor';
import { EditorConfig } from '../../../config';
import { NoticeBoardDto } from '@/dto';
import { NOTICE_BOARD, CONST_NOTICE_BOARD } from '@/services/shared';
import toast from '../../../../resources/assets/js/services/toast.js';

import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '../../../services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import NoticeBoardService from '../../../services/notice-board.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { YN } from '@/common';

@Component({
  name: 'NoticeBoardUpdate',
  components: {
    VueEditor,
  },
})
export default class NoticeBoardUpdate extends BaseComponent {
  @Prop() editMode: boolean;
  @Prop() oldAttachments: FileAttachmentDto[];
  private noticeBoardDto = new NoticeBoardDto();
  private noticeBoardUpdateDto = new NoticeBoardDto();
  private htmlContent = null;
  private noticeBoardTypes: NOTICE_BOARD[] = [...CONST_NOTICE_BOARD];
  private editorToolbar = EditorConfig;
  private startDate = new Date();
  private endDate = new Date();
  // private oldAttachments = this.uploadedAttachments;
  private newAttachments: FileAttachmentDto[] = [];

  // 수정 취소
  cancelUpdate() {
    this.$emit('cancelUpdate');
  }

  // 수정
  update(isTempSaveYn?: YN) {
    if (isTempSaveYn === YN.NO) {
      this.noticeBoardUpdateDto.tempSaveYn = YN.NO;
    } else {
      this.noticeBoardUpdateDto.tempSaveYn = YN.YES;
    }
    if (this.oldAttachments && this.oldAttachments.length > 0) {
      this.noticeBoardUpdateDto.attachments = this.oldAttachments;
      this.noticeBoardUpdateDto.newAttachments = this.newAttachments;
    }

    if (
      this.oldAttachments &&
      this.oldAttachments.length < 1 &&
      this.newAttachments &&
      this.newAttachments.length > 0
    ) {
      this.noticeBoardUpdateDto.attachments = [];
      this.noticeBoardUpdateDto.newAttachments = this.newAttachments;
    }
    if (
      this.oldAttachments &&
      this.oldAttachments.length < 1 &&
      this.newAttachments &&
      this.newAttachments.length < 1
    ) {
      this.noticeBoardUpdateDto.newAttachments = [];
      this.noticeBoardUpdateDto.attachments = [];
    }
    if (
      this.oldAttachments &&
      this.oldAttachments.length === 0 &&
      this.newAttachments &&
      this.newAttachments.length > 0
    ) {
      this.noticeBoardUpdateDto.attachments = this.newAttachments;
      this.noticeBoardUpdateDto.newAttachments = [];
    }

    NoticeBoardService.update(
      this.$route.params.id,
      this.noticeBoardUpdateDto,
    ).subscribe(res => {
      if (res) {
        this.$router.push('/notice-board');
        if (isTempSaveYn === YN.NO) {
          toast.success('수정 완료');
        } else {
          toast.success('임시 저장 완료');
        }
      }
    });
  }

  async upload(files: FileList) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.NOTICE_BOARD,
      files,
    );
    this.newAttachments = [];
    this.newAttachments.push(
      ...attachments.filter(
        fileAttachment =>
          fileAttachment.attachmentReasonType ===
          ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
  }

  deleteOldAttachment(attachemnt, index) {
    if (this.oldAttachments.includes(attachemnt)) {
      index = this.oldAttachments.indexOf(attachemnt);
      if (index > -1) {
        this.oldAttachments.splice(index, 1);
      }
    }
  }

  deleteNewAttachment(attachemnt, index) {
    if (this.newAttachments.includes(attachemnt)) {
      index = this.newAttachments.indexOf(attachemnt);
      if (index > -1) {
        this.newAttachments.splice(index, 1);
      }
    }
  }

  created() {
    const id = this.$route.params.id;
    NoticeBoardService.findOne(id).subscribe(res => {
      if (res) {
        this.noticeBoardUpdateDto = res.data;
      }
    });
  }
}
